/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiMatchEventIdAllLiveGet200Response } from '../models';
// @ts-ignore
import type { ApiMatchEventIdGet200Response } from '../models';
// @ts-ignore
import type { ApiMatchEventIdLiveGet200Response } from '../models';
// @ts-ignore
import type { ApiMatchEventIdPreviewGet200Response } from '../models';
// @ts-ignore
import type { ApiMatchEventIdTimelineGet200Response } from '../models';
// @ts-ignore
import type { ApiMatchEventIdTimelineLiveGet200Response } from '../models';
/**
 * MatchApi - axios parameter creator
 * @export
 */
export const MatchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdAllLiveGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiMatchEventIdAllLiveGet', 'eventId', eventId)
            const localVarPath = `/api/match/{event_id}/all/live`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get match by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiMatchEventIdGet', 'eventId', eventId)
            const localVarPath = `/api/match/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get match live data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdLiveGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiMatchEventIdLiveGet', 'eventId', eventId)
            const localVarPath = `/api/match/{event_id}/live`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdPreviewGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiMatchEventIdPreviewGet', 'eventId', eventId)
            const localVarPath = `/api/match/{event_id}/preview`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get match timeline by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdTimelineGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiMatchEventIdTimelineGet', 'eventId', eventId)
            const localVarPath = `/api/match/{event_id}/timeline`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdTimelineLiveGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiMatchEventIdTimelineLiveGet', 'eventId', eventId)
            const localVarPath = `/api/match/{event_id}/timeline/live`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatchApi - functional programming interface
 * @export
 */
export const MatchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatchApiAxiosParamCreator(configuration)
    return {
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatchEventIdAllLiveGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMatchEventIdAllLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatchEventIdAllLiveGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchApi.apiMatchEventIdAllLiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get match by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatchEventIdGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMatchEventIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatchEventIdGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchApi.apiMatchEventIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get match live data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatchEventIdLiveGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMatchEventIdLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatchEventIdLiveGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchApi.apiMatchEventIdLiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatchEventIdPreviewGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMatchEventIdPreviewGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatchEventIdPreviewGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchApi.apiMatchEventIdPreviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get match timeline by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatchEventIdTimelineGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMatchEventIdTimelineGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatchEventIdTimelineGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchApi.apiMatchEventIdTimelineGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatchEventIdTimelineLiveGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMatchEventIdTimelineLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatchEventIdTimelineLiveGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchApi.apiMatchEventIdTimelineLiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MatchApi - factory interface
 * @export
 */
export const MatchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatchApiFp(configuration)
    return {
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {MatchApiApiMatchEventIdAllLiveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdAllLiveGet(requestParameters: MatchApiApiMatchEventIdAllLiveGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMatchEventIdAllLiveGet200Response> {
            return localVarFp.apiMatchEventIdAllLiveGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get match by id from Sportradar API
         * @param {MatchApiApiMatchEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdGet(requestParameters: MatchApiApiMatchEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMatchEventIdGet200Response> {
            return localVarFp.apiMatchEventIdGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get match live data by id from Sportradar API
         * @param {MatchApiApiMatchEventIdLiveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdLiveGet(requestParameters: MatchApiApiMatchEventIdLiveGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMatchEventIdLiveGet200Response> {
            return localVarFp.apiMatchEventIdLiveGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
         * @param {MatchApiApiMatchEventIdPreviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdPreviewGet(requestParameters: MatchApiApiMatchEventIdPreviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMatchEventIdPreviewGet200Response> {
            return localVarFp.apiMatchEventIdPreviewGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get match timeline by id from Sportradar API
         * @param {MatchApiApiMatchEventIdTimelineGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdTimelineGet(requestParameters: MatchApiApiMatchEventIdTimelineGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMatchEventIdTimelineGet200Response> {
            return localVarFp.apiMatchEventIdTimelineGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {MatchApiApiMatchEventIdTimelineLiveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdTimelineLiveGet(requestParameters: MatchApiApiMatchEventIdTimelineLiveGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMatchEventIdTimelineLiveGet200Response> {
            return localVarFp.apiMatchEventIdTimelineLiveGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiMatchEventIdAllLiveGet operation in MatchApi.
 * @export
 * @interface MatchApiApiMatchEventIdAllLiveGetRequest
 */
export interface MatchApiApiMatchEventIdAllLiveGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MatchApiApiMatchEventIdAllLiveGet
     */
    readonly eventId: string
}

/**
 * Request parameters for apiMatchEventIdGet operation in MatchApi.
 * @export
 * @interface MatchApiApiMatchEventIdGetRequest
 */
export interface MatchApiApiMatchEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MatchApiApiMatchEventIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for apiMatchEventIdLiveGet operation in MatchApi.
 * @export
 * @interface MatchApiApiMatchEventIdLiveGetRequest
 */
export interface MatchApiApiMatchEventIdLiveGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MatchApiApiMatchEventIdLiveGet
     */
    readonly eventId: string
}

/**
 * Request parameters for apiMatchEventIdPreviewGet operation in MatchApi.
 * @export
 * @interface MatchApiApiMatchEventIdPreviewGetRequest
 */
export interface MatchApiApiMatchEventIdPreviewGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MatchApiApiMatchEventIdPreviewGet
     */
    readonly eventId: string
}

/**
 * Request parameters for apiMatchEventIdTimelineGet operation in MatchApi.
 * @export
 * @interface MatchApiApiMatchEventIdTimelineGetRequest
 */
export interface MatchApiApiMatchEventIdTimelineGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MatchApiApiMatchEventIdTimelineGet
     */
    readonly eventId: string
}

/**
 * Request parameters for apiMatchEventIdTimelineLiveGet operation in MatchApi.
 * @export
 * @interface MatchApiApiMatchEventIdTimelineLiveGetRequest
 */
export interface MatchApiApiMatchEventIdTimelineLiveGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MatchApiApiMatchEventIdTimelineLiveGet
     */
    readonly eventId: string
}

/**
 * MatchApi - object-oriented interface
 * @export
 * @class MatchApi
 * @extends {BaseAPI}
 */
export class MatchApi extends BaseAPI {
    /**
     * Get match live timeline data by id from Sportradar API
     * @param {MatchApiApiMatchEventIdAllLiveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    public apiMatchEventIdAllLiveGet(requestParameters: MatchApiApiMatchEventIdAllLiveGetRequest, options?: RawAxiosRequestConfig) {
        return MatchApiFp(this.configuration).apiMatchEventIdAllLiveGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get match by id from Sportradar API
     * @param {MatchApiApiMatchEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    public apiMatchEventIdGet(requestParameters: MatchApiApiMatchEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return MatchApiFp(this.configuration).apiMatchEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get match live data by id from Sportradar API
     * @param {MatchApiApiMatchEventIdLiveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    public apiMatchEventIdLiveGet(requestParameters: MatchApiApiMatchEventIdLiveGetRequest, options?: RawAxiosRequestConfig) {
        return MatchApiFp(this.configuration).apiMatchEventIdLiveGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
     * @param {MatchApiApiMatchEventIdPreviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    public apiMatchEventIdPreviewGet(requestParameters: MatchApiApiMatchEventIdPreviewGetRequest, options?: RawAxiosRequestConfig) {
        return MatchApiFp(this.configuration).apiMatchEventIdPreviewGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get match timeline by id from Sportradar API
     * @param {MatchApiApiMatchEventIdTimelineGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    public apiMatchEventIdTimelineGet(requestParameters: MatchApiApiMatchEventIdTimelineGetRequest, options?: RawAxiosRequestConfig) {
        return MatchApiFp(this.configuration).apiMatchEventIdTimelineGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get match live timeline data by id from Sportradar API
     * @param {MatchApiApiMatchEventIdTimelineLiveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    public apiMatchEventIdTimelineLiveGet(requestParameters: MatchApiApiMatchEventIdTimelineLiveGetRequest, options?: RawAxiosRequestConfig) {
        return MatchApiFp(this.configuration).apiMatchEventIdTimelineLiveGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
}

